import * as React from 'react'
import { ImCalendar } from 'react-icons/im'

export type InputDateProps = React.InputHTMLAttributes<HTMLInputElement>

export const InputDate = ({ type = 'date', ...rest }: InputDateProps) => {
  return (
    <div className="input-date-container">
      <input
        type="date"
        className="no-calendar"
        data-placeholder="yyyy-mm-dd"
        {...rest}
      />
      <ImCalendar size={20} color=" #004687" />
    </div>
  )
}
